import React, { createContext, useState, useEffect } from 'react';

export const LangContext = createContext(null);
const LANGUAGE_STORAGE_KEY = 'app-language';
const LEGACY_LANGUAGE_STORAGE_KEYS = ['language', 'langSelected', 'lang'];
const DEFAULT_LANGUAGE = 'ru';

const normalizeLanguage = (value) => {
    if (typeof value !== 'string') {
        return null;
    }

    const normalizedValue = value.trim().toLowerCase();

    if (normalizedValue === 'en' || normalizedValue === 'english') {
        return 'en';
    }

    if (normalizedValue === 'ru' || normalizedValue === 'russian') {
        return 'ru';
    }

    return null;
};

const getInitialLanguage = () => {
    const storageKeys = [LANGUAGE_STORAGE_KEY, ...LEGACY_LANGUAGE_STORAGE_KEYS];

    for (const storageKey of storageKeys) {
        const storedLanguage = normalizeLanguage(localStorage.getItem(storageKey));

        if (storedLanguage) {
            return storedLanguage;
        }
    }

    return DEFAULT_LANGUAGE;
};

export const LangProvider = ({ children }) => {
    const [langSelected, setLangSelected] = useState(getInitialLanguage);

    useEffect(() => {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, langSelected);
    }, [langSelected]);

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === LANGUAGE_STORAGE_KEY && event.newValue) {
                const nextLanguage = normalizeLanguage(event.newValue);

                if (nextLanguage) {
                    setLangSelected(nextLanguage);
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);


    const value = {
        langSelected,
        setLangSelected
    };

    return (
        <LangContext.Provider value={value}>
            {children}
        </LangContext.Provider>
    );
};
